import styled from 'styled-components';
import calendar from '../../../assets/calendar.svg';
import mask from 'react-input-mask';

export const InputContainer = styled.label`
  position: relative;
  width: 100%;
  font-size: 1.4rem;
  border-top: 20px solid transparent;
  margin-bottom: 5px;
  --field-padding: 12px;

  &:focus + .placeholder,
  &:not(:placeholder-shown) + .placeholder {
    top: -10px;
    color: #222;
  }
`;

export const InputGeneral = styled.input`
  color: ${({ location }) => (location !== '/' ? 'var(--color)' : '#fff')};
  background: #f2f2f2;
  padding: var(--field-padding);
  border-radius: 3px;
  width: 100%;
  outline: none;
  margin-bottom: 5px;
  background: none;
  font-family: 'GothamLight', Arial, Helvetica, sans-serif;
  border: ${({ error }) =>
    error ? '2px solid var(--danger)' : '2px solid #c0c0c0'};
  transition: border-color 0.3s ease;
  &:disabled {
    background: #ddd;
    color: #000;
  }
  & + .placeholder {
    left: 8px;
    padding: 0 5px;
  }

  &:not(:placeholder-shown),
  &:focus {
    border-color: ${({ error }) =>
      error ? 'var(--danger)' : 'var(--primary)'};
    transition-delay: 0.1s;
  }

  &:not(:placeholder-shown) + .placeholder,
  &:focus + .placeholder {
    top: 0;
    font-size: 1.4rem;
    color: ${({ error }) => (error ? 'var(--danger)' : 'var(--primary)')};
    background: ${({ location }) =>
      location !== '/' ? 'var(--background-color)' : 'var(--secondary)'};
    width: auto;
    font-family: 'GothamBold';
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    ${({ location }) =>
      location !== '/'
        ? `
        -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
      `
        : `
        -webkit-box-shadow: 0 0 0 1000px #404040 inset !important;
        -webkit-text-fill-color: white !important;
      `}
  }
  &[type='date']::-webkit-calendar-picker-indicator {
    opacity: 1;
    display: block;
    color: var(--color);
    background: url(${calendar}) no-repeat;
    width: 20px;
    height: 20px;
    border-width: thin;
    cursor: pointer;
  }
  &[type='date'] {
    cursor: pointer;
  }
`;

export const InputMask = styled(mask)`
  color: ${({ location }) => (location !== '/' ? 'var(--color)' : '#fff')};
  background: #f2f2f2;
  padding: var(--field-padding);
  border-radius: 3px;
  width: 100%;
  outline: none;
  margin-bottom: 5px;
  background: none;
  font-family: 'GothamLight', Arial, Helvetica, sans-serif;
  border: ${({ error }) =>
    error ? '2px solid var(--danger)' : '2px solid #c0c0c0'};
  transition: border-color 0.3s ease;
  &:disabled {
    background: #ddd;
    color: #000;
  }
  & + .placeholder {
    left: 8px;
    padding: 0 5px;
  }

  &:not(:placeholder-shown),
  &:focus {
    border-color: ${({ error }) =>
      error ? 'var(--danger)' : 'var(--primary)'};
    transition-delay: 0.1s;
  }

  &:not(:placeholder-shown) + .placeholder,
  &:focus + .placeholder {
    top: 0;
    font-size: 1.4rem;
    color: ${({ error }) => (error ? 'var(--danger)' : 'var(--primary)')};
    background: ${({ location }) =>
      location !== '/' ? 'var(--background-color)' : 'var(--secondary)'};
    width: auto;
    font-family: 'GothamBold';
  }
  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus,
  &:-webkit-autofill:active {
    ${({ location }) =>
      location !== '/'
        ? `
        -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
      `
        : `
        -webkit-box-shadow: 0 0 0 1000px #404040 inset !important;
        -webkit-text-fill-color: white !important;
      `}
  }
  &[type='date']::-webkit-calendar-picker-indicator {
    opacity: 1;
    display: block;
    color: var(--color);
    background: url(${calendar}) no-repeat;
    width: 20px;
    height: 20px;
    border-width: thin;
    cursor: pointer;
  }
  &[type='date'] {
    cursor: pointer;
  }
`;

export const Label = styled.label`
  position: absolute;
  left: var(--field-padding);
  width: calc(100% - (var(--field-padding) * 2));
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  top: 22px;
  line-height: 100%;
  transform: translateY(-50%);
  color: ${({ error }) => (error ? 'var(--danger)' : '#aaa')};
  transition: top 0.3s ease, color 0.3s ease, font-size 0.3s ease;
`;

export const LabelIcon = styled.div`
  position: absolute;
  overflow: hidden;
  top: 10px;
  right: 15px;
  z-index: 999;
  cursor: pointer;
  padding: 0;
  margin: 0;
`;
